import { useRef, useEffect, useCallback, PropsWithChildren, FC, useState } from 'react'
import { Spin } from 'antd'
import { Column } from '@antv/g2plot';
import Card from '@/pages/Tbqy/components/components/Card'
import CardContainer from '@/pages/Bmjy/components/components/CardContainer'

const data = [];

for(let i=0; i<12; i++) {
  data.push({
    "label": i+ 1 + "月",
    "type": "收入",
    "value": Math.floor(Math.random()*100)
  })
  data.push({
    "label": i+ 1 + "月",
    "type": "支出",
    "value": Math.floor(Math.random()*100)
  })
}

const tabsOptions = [
  {
    label: '按公司',
    value: 'ags',
    api: null
  }, 
  {
    label: '按院', 
    value: 'ay',
    api: null
  }, 
  {
    label: '按所', 
    value: 'as',
    api: null
  }
]

type PropType = FC<PropsWithChildren<{
  updateTime: string
}>>

const Component: PropType = ({updateTime}) => {
  const containerRef = useRef()
  const [loading, setLoading] = useState(false)
  const globalRef = useRef({
    params: {
      tab: '',
      depart: ''
    },
    column: null as Column,
    loadTime: updateTime
  })

  useEffect(() => {
    globalRef.current.column = new Column(containerRef.current, {
      data: [],
      xField: 'label',
      yField: 'value',
      seriesField: 'type',
      isGroup: true,
      legend: {
        position: 'bottom',
      },
      columnStyle: {
      },
      yAxis: {
        label: {
          formatter: (text) => {
            return text + '万'
          }
        }
      }
    });

    globalRef.current.column.render();
    globalRef.current.column.changeData(data)
  }, [])
  
  // 获取图表数据
  const getColumnData = useCallback(async () => {
    const tabOption = tabsOptions.find(t => t.value === globalRef.current.params.tab)
    if(!tabOption || !tabOption.api) {
      return
    }

    const res = await tabOption.api()
    if(res.success) {
      globalRef.current.column.changeData(res.data.list.reduce((c, n) => {
        c.push({
          label: n.time,
          value: n.jnZBnum || n.jnTBnum || 0,
          type: '今年'
        })
        c.push({
          label: n.time,
          value: n.qnZBnum || n.qnTBnum || 0,
          type: '去年'
        })
        return c
      }, []))
    }
  }, [])

  // 获取统计数据
  const getTotal = useCallback(async () => {
    
  }, [])

  // 获取接口数据
  const getList = useCallback(async () => {
    setLoading(true)
    Promise.all([getColumnData(), getTotal()]).finally(() => {
      setLoading(false)
    })
  }, [getColumnData, getTotal])

  // 变更类型
  const handleTabChange = useCallback((value) => {
    globalRef.current.params = value
    getList()
  }, [getList])

  useEffect(() => {
    if(globalRef.current.loadTime !== updateTime) {
      globalRef.current.loadTime = updateTime
      getList()
    }
  }, [updateTime, getList])

  return (
    <Spin spinning={loading} wrapperClassName='full-spin'>
      <Card title="收支统计" className='full-card'>
        <CardContainer
          tabs={tabsOptions}
          onTabChange={handleTabChange}
          hasExport={false}
          hasDepartSelect
        >
          <div className='flex h-full flex-column pt-20'>
            <div className='flex ml-20'>
              <div className='flex-1'>
                <div className='text-999'>本年收入合计（万）</div>
                <div className='font-30 text-primary'>54923.98</div>
              </div>
              <div className='flex-1'>
                <div className='text-999'>本年支出合计（万）</div>
                <div className='font-30'>54923.98</div>
              </div>
            </div>
            <div className='mt-10 flex-1 h-0'>
              <div className='h-full' ref={containerRef}></div>
            </div>
          </div>
        </CardContainer>
      </Card>
    </Spin>
  )
}

export default Component
